/* Keep the comparison in view while reviews above it finish loading. */
(() => {
  const link = document.querySelector('.tc-price-context__comparison');
  const target = document.getElementById('porownanie');
  const content = document.getElementById('MainContent');
  if (!link || !target || !content) return;

  let stopTracking;
  link.addEventListener('click', (event) => {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    if (stopTracking) stopTracking();
    history.replaceState(null, '', '#porownanie');

    let height = content.getBoundingClientRect().height;
    const observer = new ResizeObserver(() => {
      const nextHeight = content.getBoundingClientRect().height;
      if (Math.abs(nextHeight - height) > 1) {
        height = nextHeight;
        target.scrollIntoView({ behavior: 'instant', block: 'start' });
      }
    });
    const stop = () => {
      observer.disconnect();
      clearTimeout(timer);
      for (const type of ['wheel', 'touchstart', 'keydown']) window.removeEventListener(type, stop);
      stopTracking = null;
    };
    const timer = setTimeout(stop, 4000);
    stopTracking = stop;
    for (const type of ['wheel', 'touchstart', 'keydown']) window.addEventListener(type, stop, { passive: true });
    observer.observe(content);
    target.scrollIntoView({
      behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
      block: 'start',
    });
  });
})();
